/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import api from "../api/api";
import Banner from "../components/park/Banner";
import Ticket from "../components/park/Ticket";
import { setBranches, setRange } from "../store/features/branchSlice";
import Style from "../assets/css/main.module.css";

export default function Park() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [park, setPark] = useState({});
  const fetch = useCallback(async () => {
    const res = await api.park(id);
    if (res.status === 200) {
      setPark(res.data.data);
      if (res.data.data.branches[0]) {
        dispatch(setBranches(res.data.data.branches));
        dispatch(
          setRange([res.data.data.min_price - 50, res.data.data.max_price + 50])
        );
      } else {
        dispatch(setBranches([]));
        dispatch(setRange([0, 0]));
      }
    }
  }, [id, dispatch]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={Style.content_container}>
      <div className="d-flex flex-column flex-md-row justify-content-between park-details">
        <div className="left-content shadow-lg">
          <div className="left-inner h-100 p-0">
            <Banner park={park} />
          </div>
        </div>
        <div className="right-content">
          <div className="right-inner">
            <Ticket park={park} />
          </div>
        </div>
      </div>
    </div>
  );
}
